"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcafCollection = exports.CardholderAuthentication = exports.SecurityProtocol = exports.ExpenseFamily = exports.SupplierDocumentType = void 0;
var SupplierDocumentType;
(function (SupplierDocumentType) {
    SupplierDocumentType["TICKET"] = "TICKET";
    SupplierDocumentType["FACTURA"] = "FACTURA";
    SupplierDocumentType["NOT_SET"] = "NOT_SET";
})(SupplierDocumentType = exports.SupplierDocumentType || (exports.SupplierDocumentType = {}));
var ExpenseFamily;
(function (ExpenseFamily) {
    ExpenseFamily["CARD"] = "CARD";
    ExpenseFamily["BALANCE_AMENDMENT"] = "BALANCE_AMENDMENT";
    ExpenseFamily["PERSONAL_TRANSFER"] = "PERSONAL_TRANSFER";
    ExpenseFamily["BILL_INVOICE"] = "BILL_INVOICE";
    ExpenseFamily["BILL_INVOICE_PAYMENT"] = "BILL_INVOICE_PAYMENT";
    ExpenseFamily["LOAD"] = "LOAD";
    ExpenseFamily["MANUAL"] = "MANUAL";
    ExpenseFamily["MANUAL_TRANSFER"] = "MANUAL_TRANSFER";
    ExpenseFamily["PLEO_INVOICE"] = "PLEO_INVOICE";
    ExpenseFamily["CASHBACK"] = "CASHBACK";
    ExpenseFamily["UNLOAD_V2"] = "UNLOAD_V2";
    ExpenseFamily["LOAD_V2"] = "LOAD_V2";
    ExpenseFamily["WALLET_WITHDRAWAL"] = "WALLET_WITHDRAWAL";
    ExpenseFamily["EMPLOYEE_BANK_TRANSFER"] = "EMPLOYEE_BANK_TRANSFER";
    ExpenseFamily["OVERDRAFT_FEE"] = "OVERDRAFT_FEE";
    ExpenseFamily["OVERDRAFT_INTEREST"] = "OVERDRAFT_INTEREST";
})(ExpenseFamily = exports.ExpenseFamily || (exports.ExpenseFamily = {}));
var SecurityProtocol;
(function (SecurityProtocol) {
    SecurityProtocol["RESERVED_EXISTING"] = "0";
    SecurityProtocol["RESERVED_FUTURE"] = "1";
    SecurityProtocol["CHANNEL"] = "2";
    SecurityProtocol["NONE"] = "9";
    SecurityProtocol["UNKNOWN"] = "X";
})(SecurityProtocol = exports.SecurityProtocol || (exports.SecurityProtocol = {}));
var CardholderAuthentication;
(function (CardholderAuthentication) {
    CardholderAuthentication["RESERVED"] = "0";
    CardholderAuthentication["CARDHOLDER_CERTIFICATE_NOT_USED"] = "1";
    CardholderAuthentication["PROCESSED_THROUGH_MASTERPASS"] = "2";
    CardholderAuthentication["DIGITAL_SECURE_REMOTE_PAYMENT_TRANSACTION"] = "4";
    CardholderAuthentication["UNKNOWN"] = "X";
})(CardholderAuthentication = exports.CardholderAuthentication || (exports.CardholderAuthentication = {}));
var UcafCollection;
(function (UcafCollection) {
    UcafCollection["NOT_SUPPORTED_NOT_USED"] = "0";
    UcafCollection["SUPPORTED"] = "1";
    UcafCollection["ENABLED"] = "2";
    UcafCollection["ENABLED_MUPP_PROCESSED"] = "3";
    UcafCollection["RESERVED_FUTURE"] = "4";
    UcafCollection["ISSUER_RISK_BASED_DECISIONING"] = "5";
    UcafCollection["MERCHANT_RISK_BASED_DECISIONING"] = "6";
    UcafCollection["PARTIAL_SHIPMENT_OR_RECURRING_PAYMENT"] = "7";
    UcafCollection["UNKNOWN"] = "X";
})(UcafCollection = exports.UcafCollection || (exports.UcafCollection = {}));
//# sourceMappingURL=expense.js.map